import React, { Component } from "react";

import { PostDetail, Categories, RecentPostWidget, Author, Comments, CommentsForm, Loader } from "../..";
import { getPostDetails } from "../../../services";
import { AdjacentPosts } from "../..";

class PostDetails extends Component {
	state = { post: {}, isLoading: true };
	componentDidMount() {
		this.getPostData();
	}

	getPostData = async () => {
		const { match } = this.props;
		const { params } = match;
		const { postId } = params;
		const data = await getPostDetails(postId);
		this.setState({ post: data, isLoading: false });
		// console.log(data);
	};

	render() {
		const { post, isLoading } = this.state;
		return (
			<>
				{isLoading ? (
					<Loader />
				) : (
					<div className="container mx-auto px-10 mb-8">
						<div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
							<div className="col-span-1 lg:col-span-8">
								<PostDetail post={post} />
								<Author author={post.author} />
								<AdjacentPosts slug={post.slug} createdAt={post.createdAt} />
								<CommentsForm slug={post.slug} />
								<Comments slug={post.slug} />
							</div>
							<div className="col-span-1 lg:col-span-4">
								<div className="relative lg:sticky top-8">
									<div>
									<RecentPostWidget
										slug={post.slug}
										categories={post.categories.map(
											(category) => category.slug
										)}
									/>
									</div>
									<div>
									<Categories />
									</div>
									
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}
export default PostDetails;


